// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1z1yw","footer":"styles_footer__nd75J"};